import {TraceableBoolean, TraceableText} from "../traceable";
import {CashflowPattern} from "../pattern/cashflow-pattern";

export interface CashflowPatternGroup {
    id?: number;
    name: TraceableText;
    description: TraceableText;
    createdBy: string;
    createdByUserId: number;
    createdAt: string;
    isDefault: TraceableBoolean;
    isFavourite: TraceableBoolean;
    isArchived: TraceableBoolean;
    modifiedBy?: string;
    modifiedAt?: string;
    assignments: TemplatePatternAssignment[];
}

export interface TemplatePatternAssignment {
    id?: number;
    scenarioTypeCode: string;
    patternTypeCode: string;
    pattern: CashflowPattern;
}

export interface GroupFilterQuery {
    showFavourites: boolean;
    showArchived: boolean;
}

export const EMPTY_GROUP_FILTER_QUERY: GroupFilterQuery = {
    showFavourites: false,
    showArchived: false,
};

export function isGroupComplete(group: CashflowPatternGroup, patternTypeCodes: string[]): boolean {
    const scenarios = ["LOW", "BASE", "HIGH"];
    return patternTypeCodes.every(patternType =>
        scenarios.every(scenario =>
            group.assignments.some(a =>
                a.patternTypeCode === patternType && a.scenarioTypeCode === scenario
            )
        )
    );
}
